<script setup>
import { toRef } from 'vue';
import { useChannelIcon } from './provider';
import Avatar from 'next/avatar/Avatar.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const channelIcon = useChannelIcon(toRef(props, 'inbox'));
</script>

<template>
  <Avatar
    :src="inbox.avatar_url"
    :name="inbox.name"
    :icon-name="channelIcon"
    :size="12"
    rounded-full
  />
</template>
